module.exports = __webpack_public_path__ + "img/pie-chart.e34c8a0f.svg";